import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './selector-popup.component.html',
  styleUrls: ['./selector-popup.component.scss']
})
export class SelectorPopupComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() items: SelectorItem[];
  @Output() submit: EventEmitter<SelectorItem[]> = new EventEmitter<SelectorItem[]>();

  groups: { key: string | number, items: SelectorItem[] }[] = [];

  constructor(private modal: ModalService) { }

  ngOnInit(): void {
    this.groups = this.items.group(i => i.group);
  }

  ngOnDestroy(): void {
    this.submit.emit(this.items);
  }

  all(items: SelectorItem[]) {
    return items.first(i => !i.selected, null) == null;
  }

  some(items: SelectorItem[]) {
    return items.count(i => i.selected) < items.length;
  }

  none(items: SelectorItem[]) {
    return items.first(i => i.selected, null) == null;
  }

  toggle(items: SelectorItem[]) {

    let state = items.length > 1 ? !(items[0].selected == true) : !this.all(items);

    items.forEach(i => i.selected = state);
  }

  close() {
    this.modal.hide();
  }
}

export interface SelectorItem {

  /** name of item */
  name: string;

  /** group of item */
  group: string;

  /** icon class of item (fontawesome standard) */
  icon?: string;

  /** description of item */
  description?: string;

  /** indicates whether item is selected or not */
  selected?: boolean;

  /** data to be kept and passed back. Whatever information stored in this property will be kept untouched by SelectorPopupComponent.*/
  state?: any;
}
